export class RestoreJobConfiguration {
    'restoreEbsVolume';
    'convertEbsSnapshot';
    'restoreEc2Instance';
    'convertEc2Image';
    'restoreRdsInstance';
    'restoreEksNamespace';
    'restoreDynamoDbTable';
    'restoreAzureDisk';
    'restoreAzureVMInstance';
    'restoreGcpCloudSqlDatabase';
    'restoreGceDisk';
    'restoreGceInstance';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreEbsVolume",
            "baseName": "restoreEbsVolume",
            "type": "RestoreEbsVolumeConfig",
            "format": ""
        },
        {
            "name": "convertEbsSnapshot",
            "baseName": "convertEbsSnapshot",
            "type": "ConvertEbsSnapshotConfig",
            "format": ""
        },
        {
            "name": "restoreEc2Instance",
            "baseName": "restoreEc2Instance",
            "type": "RestoreEc2InstanceConfig",
            "format": ""
        },
        {
            "name": "convertEc2Image",
            "baseName": "convertEc2Image",
            "type": "ConvertEc2ImageConfig",
            "format": ""
        },
        {
            "name": "restoreRdsInstance",
            "baseName": "restoreRdsInstance",
            "type": "RestoreRdsInstanceConfig",
            "format": ""
        },
        {
            "name": "restoreEksNamespace",
            "baseName": "restoreEksNamespace",
            "type": "RestoreEksNamespaceConfig",
            "format": ""
        },
        {
            "name": "restoreDynamoDbTable",
            "baseName": "restoreDynamoDbTable",
            "type": "RestoreDynamoDbTableConfig",
            "format": ""
        },
        {
            "name": "restoreAzureDisk",
            "baseName": "restoreAzureDisk",
            "type": "RestoreAzureDiskConfig",
            "format": ""
        },
        {
            "name": "restoreAzureVMInstance",
            "baseName": "restoreAzureVMInstance",
            "type": "RestoreAzureVMInstanceConfig",
            "format": ""
        },
        {
            "name": "restoreGcpCloudSqlDatabase",
            "baseName": "restoreGcpCloudSqlDatabase",
            "type": "RestoreGcpCloudSqlDatabaseConfig",
            "format": ""
        },
        {
            "name": "restoreGceDisk",
            "baseName": "restoreGceDisk",
            "type": "RestoreGceDiskConfig",
            "format": ""
        },
        {
            "name": "restoreGceInstance",
            "baseName": "restoreGceInstance",
            "type": "RestoreGceInstanceConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreJobConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
